<template>
  <div>
  <div class="useBalanceBox">
    <div class="totalRow">
      <div class="balanceMonth">
        <p class="bal-month">{{month}}</p>
        <p class="bal-year">{{year}}</p>
      </div>
      <div class="balanceTotals">
        <div class="bal-company">{{balanceInfo.cusName}}</div>
        <div class="bal-datas">
          <div class="bal-data">
            <p class="bal-data-count">￥{{balanceInfo.totalNeedPay | moneyFilter}}</p>
            <p>应付总额</p>
          </div>
          <div class="bal-data">
            <p class="bal-data-count">￥{{balanceInfo.totalFactPay | moneyFilter}}</p>
            <p>实付总额</p>
          </div>
          <div class="bal-data">
            <p class="bal-data-count">￥{{balanceInfo.totalUseBalance | moneyFilter}}</p>
            <p>使用财务余额</p>
          </div>
          <div class="bal-data">
            <p  class="bal-data-count">￥{{balanceInfo.totalUsePubBalance | moneyFilter}}</p>
            <p>使用对公余额</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bal-table">
      <vxe-table
        ref="useBalance"
        :show-header="false"
        show-footer
        show-overflow
        show-footer-overflow
        :footer-span-method="footerColspanMethod"
        :footer-method="footerBalance"
        size="small"
        height="350"
        row-id="id"
        :data="balanceLists"
        :expand-config="{iconOpen: 'vxe-icon--arrow-top',iconClose: 'vxe-icon--arrow-bottom',toggleMethod: toggleExpand}"
        @toggle-row-expand="toggleExpandChangeEvent"
        :footer-cell-class-name="factPayTotal"
      >
        <vxe-table-column field="name" title="名字" width="200" >
          <template v-slot="{ row }">{{row.operateMode | dictFilter(dicts)}}/{{row.accountItemId | dictFilter(dicts)}}</template>
        </vxe-table-column>
        <vxe-table-column field="needPay" title="应付总额">
          <template v-slot="{ row }">{{row.needPay | moneyFilter}}</template>
        </vxe-table-column>
        <vxe-table-column field="factPay" title="实付总额">
          <template v-slot="{ row }">{{row.factPay | moneyFilter}}</template>
        </vxe-table-column>
        <vxe-table-column field="useBalance" title="财务余额">
          <template v-slot="{ row }">{{row.useBalance | moneyFilter}}</template>
        </vxe-table-column>
        <vxe-table-column field="usePubBalance" title="对公余额">
          <template v-slot="{ row }">{{row.usePubBalance | moneyFilter}}</template>
        </vxe-table-column>
        <vxe-table-column type="expand" class="balanceExpand" width="40">
          <template  v-slot="{ row, rowIndex }">
            <div class="expandBox">
              <ul class="expandLeft">
                <li>
                  <span>操作模式：</span>
                  <span>{{ balanceListsCopy2[rowIndex]["operateMode"]  | dictFilter(dicts)}}</span>
                </li>
                <li>
                  <span>台账项目：</span>
                  <span>{{ balanceListsCopy2[rowIndex]["accountItemId"] | dictFilter(dicts)}}</span>
                </li>
                <li>
                  <span>应付金额：</span>
                  <span class="money">{{ balanceListsCopy2[rowIndex]["needPay"]  | moneyFilter}}</span>
                </li>
                <li>
                  <span>实付金额：</span>
                  <span class="money">{{ balanceListsCopy2[rowIndex]["factPay"]  | moneyFilter}}</span>
                </li>
              </ul>
              <div class="expandRight">
                <el-form :model="balanceListsCopy2[rowIndex]"  class="useBalanceMoney"  :ref="'row'+ rowIndex">
                  <el-form-item label="可用财务余额"  class="publicBalanceTotal">
                    <span  class="money">{{getKyTotalBalance(balanceListsCopy2[rowIndex]["accountItemId"],balanceListsCopy2[rowIndex]["operateMode"],'fsBalance') | moneyFilter}}</span>
                  </el-form-item>
                  <!--这里需要把row的数据传入到rules中，但是我暂时没想到怎么把数据动态的传给自定义校验，并且这个数据还是可变的，只能先放在行内了-->
                  <el-form-item prop="useBalance" :rules="[
                  { validator: ((rule, value, callback) => {  useBalanceVal(rule, value, callback,balanceListsCopy2[rowIndex]) }),trigger: 'change'}]">

                    <div class="expandRightIcon">
                      <el-input
                        placeholder="输入抵扣金额"
                        @input="useBalanceValInput(balanceListsCopy2[rowIndex]['useBalance'],balanceListsCopy2[rowIndex],rowIndex,0,'fsBalance')"
                        v-model="balanceListsCopy2[rowIndex]['useBalance']">
                      </el-input>
                      <div class="deductIcon" v-if="balanceListsCopy2[rowIndex]['useBalance'] > 0" @click="backData(balanceListsCopy2[rowIndex],rowIndex,null,'fsBalance')">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-zuojiantou"></use>
                        </svg>
                      </div>
                    </div>
                  </el-form-item>
                </el-form>
                <el-form :model="balanceListsCopy2[rowIndex]" :ref="'pubDetail'+ rowIndex">
                  <div class="usePubBalance">
                    <p class="publicBalanceTotal mb22"><label class="el-form-item__label">可用对公余额</label><span class="money">{{getKyTotalBalance(balanceListsCopy2[rowIndex]["accountItemId"],balanceListsCopy2[rowIndex]["operateMode"],'pubBalance') | moneyFilter}}</span></p>
                    <div class="publicBalance" v-for="(item,index) in balanceListsCopy2[rowIndex]['pubDetail']" v-bind:key="index">
                      <el-form-item :label="item.trusteeOrgId | pubOrgName(pubOrgIdList)"  class="publicBalanceTotal">
                        <span  class="money">
                          {{getKyPubBalance(balanceListsCopy2[rowIndex]["accountItemId"],balanceListsCopy2[rowIndex]["operateMode"],item.trusteeOrgId) | moneyFilter}}</span>
                      </el-form-item>
                      <el-form-item  :prop="'pubDetail.'+index+ '.usePubBalance'"
                                     :rules="[{ validator: ((rule, value, callback) => {usePubBalanceVal(rule, value, callback,balanceListsCopy2[rowIndex],index) }),trigger: 'change'}]">
                        <div class="expandRightIcon">
                          <el-input  placeholder="输入抵扣金额"  v-model="item.usePubBalance"
                                     @input="useBalanceValInput(item.usePubBalance,balanceListsCopy2[rowIndex],rowIndex,index,'pubBalance')">
                          </el-input>
                          <div class="deductIcon" v-if="item.usePubBalance > 0" @click="backData(balanceListsCopy2[rowIndex],rowIndex,index,'pubBalance')">
                            <svg class="icon" aria-hidden="true"><use xlink:href="#icon-zuojiantou"></use></svg>
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
  <div
    class="marginTop30"
    style="text-align: center"
  >
    <el-button
      type="primary"
      :disabled="btnUnable"
      @click="submitBalance"
    >
      保存
    </el-button>
    <el-button @click="closeDialog()">
      取消
    </el-button>
  </div>
  </div>
</template>

<script>
  import {saveUseBalance} from "@/api/biz/bill/pay-notice"
  import {queryPubOrgList} from "@/api/orig-biz/pub-org-account"
  import { floatSum, floatSub } from "@/util/util";

  import {mapGetters} from 'vuex';
  export default {
    name: "useBalance",
    props:{
      balanceInfo:{
        type: Object,
        default: () => ({})
      },
      balanceLists: {
        type: Array,
        default: () =>([])
      },
      balanceListsCopy: {
        type: Array,
        default: () =>([])
      },
      balanceListsCopy2: {
        type: Array,
        default: () =>([])
      },
      kyBalanceList: {
        type: Array,
        default: () =>([])
      },
    },
    computed: {
      ...mapGetters(['dicts']),
    },
    created() {
      this.getCodeItemList();
    },
    data(){
      return{
        isClose:[],
        month:"",
        year:"",
        pubOrgIdList:[],
        btnUnable:false,
      }
    },
    filters: {
      pubOrgName(orgId,pubOrgIdlist){
        if(pubOrgIdlist){
          let len=pubOrgIdlist.length;
          for(let i=0;i<len;i++){
            let item=pubOrgIdlist[i];
            if(orgId==item.pubOrgId){
              return item.company;
            }
          }
        }

      },
    },
    mounted(){

      this.year = this.balanceInfo.month.substring(0,4);
      this.month = this.balanceInfo.month.substring(5);
    },
    watch: {
      kyBalanceList: {
        handler(newVal, oldVal) {
          this.$emit('update:kyBalanceList', newVal);
        },
        immediate: true,
        deep: true,
      },
      balanceLists: {
        handler(newVal, oldVal) {
          this.$emit('update:balanceLists', newVal);
        },
        immediate: true,
        deep: true,
      },
      balanceListsCopy: {
        handler(newVal, oldVal) {
          this.$emit('update:balanceListsCopy', newVal);
        },
        immediate: true,
        deep: true,
      },
      balanceListsCopy2: {
        handler(newVal, oldVal) {
          this.$emit('update:balanceListsCopy2', newVal);
        },
        immediate: true,
        deep: true,
      },
      dialogBalanceVisible:{
        handler(newVal, oldVal) {
          this.$emit('update:dialogBalanceVisible', newVal);
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {
      toggleExpand ({expanded,rowIndex}) {
        if(expanded===true){
          let item = this.balanceLists[rowIndex];
          if (item.accountItemId === "30390008") {
            this.$message.info("销项税不允许使用余额");
            return;
          } else if (item.accountItemId === "30390001") {
            this.$message.info("服务费不允许使用余额");
            return;
          }
        }
        return true;
      },
      getCodeItemList(){
        queryPubOrgList().then(res => {
          this.pubOrgIdList = res.data.data;
        });
      },
      getKyPubBalance(accountItemId,operateMode,trusteeOrgId){
        var i=0;
        var re=0;
        for (i; i < this.kyBalanceList.length; i++) {
          var account=this.kyBalanceList[i].accountItemId;
          var operate=this.kyBalanceList[i].operateMode;
          var orgid=this.kyBalanceList[i].trusteeOrgId;
          if (trusteeOrgId != null && trusteeOrgId != "null" && trusteeOrgId != "") {
            if (accountItemId === account&& operateMode ===operate&& trusteeOrgId === orgid) {
              re = this.kyBalanceList[i].pubBalance;
              break;
            }
          }
        }
        return re;
      },
      getKyTotalBalance(accountItemId,operateMode,type){
        var re=0;
        for (var i=0; i < this.kyBalanceList.length; i++) {
          var account=this.kyBalanceList[i].accountItemId;
          var operate=this.kyBalanceList[i].operateMode;
          var orgid=this.kyBalanceList[i].trusteeOrgId;
          if("fsBalance"===type){//财务余额
            if (accountItemId === account && operateMode === operate && (orgid == null || orgid == 'null'||orgid == '')) {
              re = this.kyBalanceList[i].fsBalance;
              break;
            }
          }else {//对公余额
            if (orgid != null && orgid != "null" && orgid != "") {
              if (accountItemId === account && operateMode === operate) {
                re = re+this.kyBalanceList[i].pubBalance;
                continue;
              }
            }
          }
        }

        return re;
      },

      factPayTotal ({ $rowIndex, column, columnIndex }) {
          if (columnIndex === 0) {
            return 'w120'
          }
          if (columnIndex === 1) {
            return 'money'
          }
      },
      // 校验财务余额
      testCaiwu (rowIndex){
        // 首先校验财务余额
        return new Promise((resolve, reject) => {
          this.$refs["row"+ rowIndex].validate((valid) => {
            if (valid) {
              resolve('成功了')
            } else {
              reject('失败了')
            }
          });
        })

      },
      // 校验对公余额
      testduigong(rowIndex){
        return new Promise((resolve, reject) => {
          this.$refs["pubDetail"+ rowIndex].validate((valid) => {
            if (valid) {
              resolve('成功了')
            } else {
              reject('失败了')
            }
          });
        })
      },
      toggleExpandChangeEvent ({ row,rowIndex, expanded }) {
        let that = this;
        if(!expanded){
          Promise.all([this.testCaiwu(rowIndex), this.testduigong(rowIndex)])
            .then(() => {
              that.$refs.useBalance.setRowExpansion(row, false)
            })
            .catch(error => {
              that.$refs.useBalance.setRowExpansion(row, true).then(() =>{
                this.$refs["row"+ rowIndex].validate()
                this.$refs["pubDetail"+ rowIndex].validate()
              })
            })
        }else{
        }
      },
      // 在值发生改变时更新表尾合计
      updateFooterEvent (params) {
        let xTable = this.$refs.useBalance
        xTable.updateFooter()
      },

      useBalanceVal (rule, value, callback,row) {
        var total=this.getKyTotalBalance(row.accountItemId,row.operateMode,'fsBalance')
        var needPay=row.needPay;
        var factPay=row.factPay;
        if (value > total) {
          callback(new Error('金额已超过财务余额，请检查输入！'));
        } else if(value > floatSub(needPay,factPay)) {
          console.log("needPay-factPay:",new Number(needPay)-new Number(factPay));
          callback(new Error('金额已超过待付金额，请检查输入！'));
        }else{
          callback();
        }
      },
      usePubBalanceVal (rule, value, callback,row,detailIndex) {
        var needPay=row.pubDetail[detailIndex].needPay;
        var factPay=row.pubDetail[detailIndex].factPay;
        var trusteeOrgId=row.pubDetail[detailIndex].trusteeOrgId;
        var total=this.getKyTotalBalance(row.accountItemId,row.operateMode,"pubBalance");
        var money=this.getKyPubBalance(row.accountItem,row.operateMode,trusteeOrgId);

        if (value > money) {
          callback(new Error('金额已超过分支对公金额，请检查输入！'));
        } else if (value > total) {
          callback(new Error('金额已超过对公总余额，请检查输入！'));
        } else if(value > floatSub(needPay,factPay)){
          callback(new Error('金额已超过待付金额，请检查输入！'));
        }else{
          callback();
        }
      },
      // 表尾合计
      footerBalance ({ columns, data }) {
        const footerData = [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '实付总额：'
            }
            // 合并为一列显示
            if (['needPay'].includes(column.property)) {
              this.$set(this.balanceInfo,"factPay",this.$utils.sum(data, 'factPay'))
              return "￥"+this.$utils.sum(data, 'factPay').toFixed(2)
            }
            return null
          })
        ]
        return footerData
      },
      footerColspanMethod ({ columnIndex }) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 5
          }
        } else if (columnIndex > 1) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      },
      // 格式化输入
      useBalanceValInput(val,row,rowIndex,detailIndex,type){
        const temp = val;
        // 限制两位小数数字
        val = val.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
        if(val === ""){
          val = "0"
        }
        val = val.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
        val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");

        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
        if(val.indexOf(".")< 0){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          val= parseFloat(val);
        }else if(val.indexOf(".")> 1 && val[0] === "0"){//控制0X.XX
          val= parseFloat(val);
        }else if(val.indexOf(".") === 0 ){//控制.XX
          val= parseFloat("0"+val);
        }
        if( type== 'fsBalance'){
          if(temp === ""){
            this.$set(this.balanceLists[rowIndex],"useBalance",0);
            this.$set(this.balanceListsCopy2[rowIndex],"useBalance",0);
          }else{
            if( val > this.getKyTotalBalance(row.accountItemId,row.operateMode,'fsBalance')){
              this.$set(this.balanceListsCopy2[rowIndex],"useBalance",val);
              return false;
            }else{
              this.$set(this.balanceLists[rowIndex],"useBalance",val)
              this.$set(this.balanceListsCopy2[rowIndex],"useBalance",val);
            }

          }
        }else{
          if(temp === "") {
            this.$set(this.balanceLists[rowIndex].pubDetail[detailIndex], "usePubBalance", 0);
            this.$set(this.balanceListsCopy2[rowIndex].pubDetail[detailIndex], "usePubBalance", 0);
          }else{
            if( val > this.getKyPubBalance(row.accountItemId,row.operateMode,row.pubDetail.trusteeOrgId)){
              this.$set(this.balanceListsCopy2[rowIndex].pubDetail[detailIndex], "usePubBalance", val);
              return false;
            }else{
              this.$set(this.balanceLists[rowIndex].pubDetail[detailIndex], "usePubBalance", val);
              this.$set(this.balanceListsCopy2[rowIndex].pubDetail[detailIndex], "usePubBalance", val);
            }


          }
          var rowPubBalance = 0;
          for(var i=0;i<this.balanceLists[rowIndex].pubDetail.length;i++) {
            rowPubBalance=floatSum([rowPubBalance,parseFloat(this.balanceLists[rowIndex].pubDetail[i].usePubBalance)]);
          }
          this.$set(this.balanceLists[rowIndex], "usePubBalance", rowPubBalance);
          this.$set(this.balanceListsCopy2[rowIndex], "usePubBalance", rowPubBalance);
        }
        let factPay=floatSub(this.balanceLists[rowIndex].needPay,[this.balanceLists[rowIndex].useBalance,this.balanceLists[rowIndex].usePubBalance]);
        this.$set(this.balanceLists[rowIndex], "factPay", factPay);
        this.$set(this.balanceListsCopy2[rowIndex], "factPay", factPay);

        let pubTotal = 0;
        let fsTotal = 0;

        // 累加所有的余额
        for(var i=0; i< this.balanceLists.length;i++){
          var item=this.balanceLists[i];
          if(item.usePubBalance){
            pubTotal = floatSum([pubTotal,parseFloat(item.usePubBalance)])
          }
          if(item.useBalance){
            fsTotal = floatSum([fsTotal,parseFloat(item.useBalance)])
          }
        }
        let totalFactPay = floatSub(this.balanceInfo.totalNeedPay,[pubTotal,fsTotal]);
        this.$set(this.balanceInfo,"totalFactPay", totalFactPay);
        this.$set(this.balanceInfo,"totalUseBalance", fsTotal);
        this.$set(this.balanceInfo,"totalUsePubBalance", pubTotal);
        // 计算合计
        this.updateFooterEvent();
      },

      // 清空数据
      backData(row,rowIndex,detailIndex,type){
        if( type== 'fsBalance'){
          this.$set(this.balanceLists[rowIndex],"useBalance",0);
        }else{
          this.$set(this.balanceLists[rowIndex].pubDetail[detailIndex],"usePubBalance",0);
        }
        this.useBalanceValInput("", row, rowIndex,detailIndex, type);
      },

      // 校验全部
      testAll(i,total){
        // 只校验打开的展开行
        if('30390002'==this.balanceLists[i].accountItemId){ //只有工资往来校验余额
          if(this.$refs["row"+ i]){
            // 首先校验财务余额
            this.$refs["row"+ i].validate((valid) => {
              if (valid) {
              } else {
                this.isClose.push(i)
              }
            });
            // 其次校验对公余额
            this.$refs["pubDetail"+ i].validate((valid) => {
              if (valid) {
              } else {
                this.isClose.push(i)
              }
            });
          }
        }

        if(i > 0){
          this.testAll(i - 1,total)
        }
        if(i == 0){
          // 去重
          const close = [...new Set(this.isClose)];
            if(close.length === 0){
              this.balanceInfo.useBalanceList=this.balanceLists;
              this.btnUnable=true;
              saveUseBalance(this.balanceInfo).then(res => {
                if(res.data.code==0) {
                  this.$message.success(res.data.msg);
                  this.closeDialog();
                }else{
                  this.$message.error(res.data.msg);
                  this.btnUnable=false;
                }
              })
            }else{
              this.btnUnable=false;
              this.$message.error("有数据未通过校验，请检查！")
            }
        }
      },
      // 提交
      submitBalance() {
        const that = this;
        that.$nextTick(() => {
          const rowsNo = that.balanceLists.length - 1;
          that.isClose = [];

          that.testAll(rowsNo, rowsNo)
        })
      },
      closeDialog(){
        this.$emit("closeDialog")
      }
    }
  };
</script>

<style scoped>

</style>
